export default __webpack_public_path__ + "media/verify_user_account_email/title_locale_nb-6cfee11c.png";